import moment from "moment";

export function getDescrizioneSpecialita(specObj, idLingua) {
  let desc = "";
  switch (idLingua) {
    case 1:
      desc = specObj.titoloWebLang1;
      break;
    case 2:
      desc = specObj.titoloWebLang2;
      break;
    case 3:
      desc = specObj.titoloWebLang3;
      break;
    case 4:
      desc = specObj.titoloWebLang4;
      break;
    case 5:
      desc = specObj.titoloWebLang5;
      break;
    default:
      desc = specObj.descrSpecialita;
  }

  if (desc === undefined) return specObj.descrSpecialita;
  if (desc === null) return specObj.descrSpecialita;
  if (desc === "") return specObj.descrSpecialita;
  return desc;
}

// export function getLivelli(livelliSkiwork, livelloInternazionale) {
//   if (!livelloInternazionale) {
//     const livelliArray = livelliSkiwork.map((x, idx) => {
//       const el = {
//         key: x.id.toString(),
//         text: x.livello,
//         img: require(`../assets/images/livelli/${idx + 1}.jpg`),
//       };
//       return el;
//     });
//     return livelliArray;
//   } else {
//     const livelliArray = livelliSkiwork.map((x, idx) => {
//       const el = {
//         key: x.id.toString(),
//         text: x.livello,
//         img: require(`../assets/images/livelli/${idx + 1}+.jpg`),
//       };
//       return el;
//     });
//     return livelliArray;
//   }

export function getLivelli(datiScuola, idCorso) {
  const livelliFiltrati = [...datiScuola.tLivelli];

  if (idCorso !== undefined) {
    const livelliNascostiCorso = datiScuola.livelliNascosti.filter(
      (x) => x.idCorso === idCorso
    );
    for (let i = 0; i < livelliNascostiCorso.length; i++) {
      livelliFiltrati.splice(
        livelliFiltrati.findIndex(
          (x) => x.idLivelloIso === livelliNascostiCorso[i].idLivelloISO
        ),
        1
      );
    }
  }

  const livelliArray = livelliFiltrati.map((x, idx) => {
    const el = {
      key: x.id.toString(),
      text: x.livello,
      img: require(`../assets/images/livelli/${x.simbolo}.jpg`),
      infoString: x.descrizione,
    };

    return el;
  });

  return livelliArray.filter((x) => x.text.charAt(0) !== "*");
}

export function getLivelliZona(datiScuola, idZona) {
  const livelliFiltrati = [...datiScuola.tLivelli];

  if (idZona !== undefined) {
    const livelliNascostiZona = datiScuola.livelliNascostiZona.filter(
      (x) => x.idZona === idZona
    );
    for (let i = 0; i < livelliNascostiZona.length; i++) {
      livelliFiltrati.splice(
        livelliFiltrati.findIndex(
          (x) => x.idLivelloIso === livelliNascostiZona[i].idLivelloISO
        ),
        1
      );
    }
  }

  const livelliArray = livelliFiltrati.map((x, idx) => {
    const el = {
      key: x.id.toString(),
      text: x.livello,
      img: require(`../assets/images/livelli/${x.simbolo}.jpg`),
      infoString: x.descrizione,
    };

    return el;
  });

  return livelliArray;
}

export function isSchoolPromoActive(promozione, sconto, scadenza) {
  if (!promozione || !sconto || sconto <= 0) return false;
  if (!scadenza) return false;
  const today = moment().startOf("day");
  const deadline = moment(scadenza).endOf("day");
  return today.isBefore(deadline) || today.isSame(deadline, "day");
}

export function getEffectiveCourseDiscount(corso, datiScuola) {
  const isCoursePromo = corso?.promozione ?? corso?.Promozione;
  if (isCoursePromo) {
    const sconto = corso.scontoPromozione ?? corso.ScontoPromozione;
    const scadenza = corso.scadenzaPromozione ?? corso.ScadenzaPromozione;
    if (sconto != null && sconto > 0 && scadenza != null) {
      const today = moment().startOf("day");
      const deadline = moment(scadenza).endOf("day");
      if (today.isBefore(deadline) || today.isSame(deadline, "day")) {
        return sconto;
      }
    }
    return 0;
  }
  const schoolPromoActive = isSchoolPromoActive(
    datiScuola.promozioneCorsi,
    datiScuola.scontoPromozioneCorsi,
    datiScuola.scadenzaPromozioneCorsi
  );
  return schoolPromoActive ? datiScuola.scontoPromozioneCorsi : 0;
}

export function applyDiscountRounding(tot, mode) {
  switch (mode) {
    case 0:
      return tot;

    case 1:
      return Math.round(tot);

    case 2: {
      const floor = Math.trunc(tot);
      if (tot === floor) return tot;
      return tot - floor < 0.5 ? floor : floor + 0.5;
    }

    case 3:
      return Math.trunc(tot);

    case 4: {
      const floor = Math.trunc(tot);
      if (tot === floor) return tot;
      return tot - floor < 0.5 ? floor + 0.5 : floor + 1;
    }

    case 5:
      return tot !== Math.trunc(tot) ? Math.trunc(tot) + 1 : tot;

    default:
      return tot;
  }
}

export function calculateDiscountedPrice(basePrice, promoPerc, agencyPerc, roundingMode) {
  let tempPrice = basePrice;
  if (agencyPerc > 0) {
    tempPrice = tempPrice * (1 - agencyPerc / 100);
  }
  if (promoPerc > 0) {
    tempPrice = tempPrice * (1 - promoPerc / 100);
  }
  return applyDiscountRounding(tempPrice, roundingMode ?? 0);
}
